import type { IconName } from "@-/dev.improve.haniverse.components.ui.icon";
import type { StudyEnvironment } from "@-/dev.improve.haniverse.lib.learn.study-environment";

export function studyEnvironmentIconName(studyEnvironment: StudyEnvironment): IconName {
  switch (studyEnvironment) {
    case "standard": {
      return "MdMenuBook";
    }
    case "silent": {
      return "MdVolumeOff";
    }
    case "no-speaking": {
      return "MdMicOff";
    }
    case "no-headphones": {
      return "MdHeadsetOff";
    }
    case "hands-free": {
      return "MdRecordVoiceOver";
    }
  }
}
